export enum TaskStatus {
    Pending,
    Running,
    Success,
    Information,
    Failure
}